import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { IQuestionCategory } from '@internal-models/question-category.model';
import { IWalkInAttendance } from '@internal-models/walk-in-attendance.model';
import { IFormGroup } from '@shared-libs/interfaces';

export class WalkInAttendanceFormFactory {
	public static create(
		questionCategories: Array<IQuestionCategory>,
		Attendances?: IWalkInAttendance
	): IFormGroup<IWalkInAttendance> {
		return new FormGroup({
			headcount: new FormControl(Attendances?.headcount || 0),
			QuestionCategories: new FormArray(
				questionCategories.map(
					(question: IQuestionCategory) =>
						new FormGroup({
							id: new FormControl(question.id),
							name: new FormControl(question.name),
							count: new FormControl(
								parseInt(
									Attendances?.QuestionCategories.find((category) => category.id === question.id)
										?.count || '0'
								)
							),
						})
				)
			),
		}) as IFormGroup;
	}
}
